/* sb-dc-packages.js - step & repeat PACKAGES as their own products in the
   design center. 2026-09-17.

   Reported: the menu's Vinyl Backdrops / Fabric Backdrops packages
   ("8'x8' Banner + Stand", "... + Stand + Red Carpet", 20 products) opened
   the design center as plain Custom Step & Repeat - banner-only price
   ($98 for an 8x8 that sells at $223) and a banner-only cart line.

   Cause: none of the 20 handles had a card in window.__CAT, so
   sb-dc-nostart.js read the handle (sb-dc-handle.js) and fell back to the
   banner-only product. That was a known, documented gap (see the notes in
   both files and sb-dc-standnotice.js).

   Fix, from outside the 341 KB bundle like popupbackdrop / yardflag / unhide:
     1. One card per package, handle = the real Shopify product, fixed at its
        banner size. nostart finds it as a direct hit ("listed") and opens it.
     2. Price = the product's own price. Each package is ONE variant, so the
        cart module's variant lookup lands on it directly and the cart line is
        the package itself (banner + stand [+ carpet]). The price is also
        re-read from /products/<handle>.js on load, so a price change in
        Shopify follows here without editing this file.
     3. Finishing: vinyl packages get the vinyl list (the bundle's default),
        fabric packages get the fabric list - same as their banner-only cards.
     4. The cards are hidden in CHOOSE PRODUCT unless selected, so the popup
        list looks exactly as before for everyone else.
     5. The "stand is not included in the price" line from
        sb-dc-standnotice.js is hidden while a package is on the board -
        it is included now.

   Nothing else is touched: other products, their cards, prices and cart
   behaviour are unchanged. To undo, remove the section that loads this file
   (templates/page.design-center.json -> sb-dc-packages).

   Diagnostics: window.__dcPackages() */
(function () {
  'use strict';
  return;   // 2026-10-01 (owner): packages open as their material's banner only - stand / red carpet are add-ons in the review window

  var FABRIC_FIN = ['hem-only', 'none', 'pockets-both', 'pockets-top'];

  /* handle, width ft, height ft, fabric?, carpet?, price (Shopify, 2026-09-17) */
  var ROWS = [
    ['8x8-step-and-repeat-banner-with-stand', 8, 8, 0, 0, 223],
    ['10x8-step-and-repeat-banner-with-stand', 10, 8, 0, 0, 277],
    ['12x8-step-and-repeat-banner-with-stand', 12, 8, 0, 0, 441],
    ['16x8-step-and-repeat-banner-with-stand', 16, 8, 0, 0, 555],
    ['20x8-step-and-repeat-banner-with-stand', 20, 8, 0, 0, 669],
    ['8x8-step-and-repeat-banner-with-stand-and-red-carpet', 8, 8, 0, 1, 266],
    ['10x8-step-and-repeat-banner-with-stand-and-red-carpet', 10, 8, 0, 1, 331],
    ['12x8-step-and-repeat-banner-with-stand-and-red-carpet', 12, 8, 0, 1, 531],
    ['16x8-step-and-repeat-banner-with-stand-and-red-carpet', 16, 8, 0, 1, 663],
    ['20x8-step-and-repeat-banner-with-stand-and-red-carpet', 20, 8, 0, 1, 795],
    ['8x8-fabric-step-and-repeat-banner-with-stand', 8, 8, 1, 0, 285],
    ['10x8-fabric-step-and-repeat-banner-with-stand', 10, 8, 1, 0, 349],
    ['12x8-fabric-step-and-repeat-banner-with-stand', 12, 8, 1, 0, 537],
    ['16x8-fabric-step-and-repeat-banner-with-stand', 16, 8, 1, 0, 683],
    ['20x8-fabric-step-and-repeat-banner-with-stand', 20, 8, 1, 0, 829],
    ['8x8-fabric-step-and-repeat-banner-with-stand-and-red-carpet', 8, 8, 1, 1, 328],
    ['10x8-fabric-step-and-repeat-banner-with-stand-and-red-carpet', 10, 8, 1, 1, 403],
    ['12x8-fabric-step-and-repeat-banner-with-stand-and-red-carpet', 12, 8, 1, 1, 627],
    ['16x8-fabric-step-and-repeat-banner-with-stand-and-red-carpet', 16, 8, 1, 1, 791],
    ['20x8-fabric-step-and-repeat-banner-with-stand-and-red-carpet', 20, 8, 1, 1, 955]
  ];

  var CARDS = {}, FABRIC = {};
  ROWS.forEach(function (r) {
    var h = r[0], w = r[1], ht = r[2], fab = !!r[3], carpet = !!r[4], price = r[5];
    var key = w + 'x' + ht, rbs = {};
    rbs[key] = price / (w * ht);
    var what = carpet ? ' + Stand + Red Carpet' : ' + Stand';
    CARDS[h] = {
      handle: h,
      name: w + "'x" + ht + "' " + (fab ? 'Fabric ' : 'Vinyl ') + 'Step and Repeat Banner with Stand' + (carpet ? ' and Red Carpet' : ''),
      nameKo: w + "'x" + ht + "' Step & Repeat (" + (fab ? 'fabric' : 'vinyl') + ')' + what,
      material: (fab ? '270gsm fabric' : 'Vinyl') + ' \u00b7 ' + w + 'ft x ' + ht + 'ft \u00b7 ' + (carpet ? 'stand and red carpet included' : 'stand included'),
      materialEn: fab ? '270gsm Tension Fabric' : 'Vinyl',
      unit: 'ft',
      rate: price / (w * ht),
      rateBySize: rbs,
      min: 4,
      w: w,
      h: ht,
      fixedOnly: true,
      presets: [key],
      qty: 1,
      ftSize: { minSide: Math.min(w, ht), maxSide: Math.max(w, ht), maxShort: Math.min(w, ht) },
      optNames: { w: '(Width) Feet', h: '(Height) Feet' }
    };
    if (fab) FABRIC[h] = true;
  });

  var info = { added: [], skipped: [], priced: {}, finWrapped: false, noticeHidden: false };
  window.__dcPackages = function () { return info; };

  function appliedHandle() {
    var p = window.__dcProduct;
    return (p && p.id) || '';
  }

  /* ---- 1. cards ---- */

  function where(cat, handle) {
    for (var i = 0; i < cat.length; i++) {
      var items = (cat[i] && cat[i].items) || [];
      for (var j = 0; j < items.length; j++) if (items[j] && items[j].handle === handle) return { c: i, i: j };
    }
    return null;
  }

  function install() {
    var cat = window.__CAT;
    if (!cat || !cat.length) return false;
    ROWS.forEach(function (r) {
      var h = r[0];
      if (where(cat, h)) return;
      var base = r[3] ? 'fabric-step-repeat-banners' : 'custom-step-and-repeat-banner';
      var at = where(cat, base);
      if (!at) { info.skipped.push(h + ': no ' + base); return; }
      cat[at.c].items.push(CARDS[h]);
      info.added.push(h);
    });
    return true;
  }

  /* ---- 2. live price from Shopify ---- */

  function refreshPrices() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    ROWS.forEach(function (r) {
      var h = r[0];
      fetch(root + 'products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (prod) {
          var v = prod && prod.variants && prod.variants[0];
          if (!v || !(v.price > 0) || prod.variants.length !== 1) return;
          var c = CARDS[h], dollars = v.price / 100, area = c.w * c.h;
          c.rate = dollars / area;
          c.rateBySize[c.w + 'x' + c.h] = dollars / area;
          info.priced[h] = dollars;
          if (appliedHandle() === h && window.__dcApi && window.__dcApi.setSpec) {
            try { window.__dcApi.setSpec({}, false); } catch (e) {}
          }
        })
        .catch(function () {});
    });
  }

  /* ---- 3. finishing for the fabric packages ---- */

  function forced() {
    return FABRIC[appliedHandle()] ? FABRIC_FIN : null;
  }

  function wrapFinishing() {
    if (typeof window.__dcFinishingAllowed !== 'function') return false;
    var pA = window.__dcFinishingAllowed;
    window.__dcFinishingAllowed = function () { return forced() || pA.apply(this, arguments); };
    var pH = window.__dcHasFinishing;
    if (typeof pH === 'function') {
      window.__dcHasFinishing = function () { return forced() ? true : pH.apply(this, arguments); };
    }
    var pL = window.__dcFinishingList;
    if (typeof pL === 'function') {
      window.__dcFinishingList = function (all) {
        var f = forced();
        return f ? (all || []).filter(function (o) { return f.indexOf(o.id) >= 0; }) : pL.apply(this, arguments);
      };
    }
    var pK = window.__dcFinishingFilterKo;
    if (typeof pK === 'function') {
      window.__dcFinishingFilterKo = function (list) {
        var f = forced();
        return f ? (list || []).filter(function (o) { return f.indexOf(o.id) >= 0; }) : pK.apply(this, arguments);
      };
    }
    info.finWrapped = true;
    return true;
  }

  /* ---- 4 + 5. CSS: hide package cards unless selected; hide the stand notice ---- */

  function cardCss() {
    if (document.getElementById('sbdc-packages-css')) return;
    var sel = ROWS.map(function (r) { return '.sbdc-prod[data-handle="' + r[0] + '"]:not(.is-on)'; }).join(',');
    var st = document.createElement('style');
    st.id = 'sbdc-packages-css';
    st.textContent = sel + '{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  }

  function noticeCss() {
    var on = !!CARDS[appliedHandle()];
    var el = document.getElementById('sbdc-packages-notice');
    if (on && !el) {
      el = document.createElement('style');
      el.id = 'sbdc-packages-notice';
      el.textContent = '#sbdc-standnotice{display:none!important}';
      (document.head || document.documentElement).appendChild(el);
    } else if (!on && el) {
      el.parentNode.removeChild(el);
    }
    info.noticeHidden = on;
  }

  /* ---- boot ---- */

  cardCss();
  var installed = install();
  var wrapped = wrapFinishing();
  if (!installed || !wrapped) {
    var tries = 0;
    var t = setInterval(function () {
      if (!installed) installed = install();
      if (!wrapped) wrapped = wrapFinishing();
      if ((installed && wrapped) || ++tries > 200) clearInterval(t);
    }, 50);
  }
  refreshPrices();
  setInterval(function () { try { noticeCss(); } catch (e) {} }, 400);
})();
